var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "7.948 0 492.052 395.231",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.1676299571990967, -43.35260391235352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3",
    transform: "matrix(1, 0, 0, 1, 0.196671, -2.421024)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.38,
    y: 398.49,
    width: 70.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.14,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 34.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.65,
    y: 390.89,
    width: 62.35,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.33,
    y: 395.11,
    width: 36.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.05,
    y: 89.87,
    width: 96.69,
    height: 266.7,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.75,
    y: 89.87,
    width: 0.98,
    height: 266.7,
    transform: "translate(318.47 446.45) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 100.05,
    width: 78.03,
    height: 246.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.18,
    y: 78.27,
    width: 228.09,
    height: 169.47,
    transform: "translate(628.46 326.01) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.65,
    y: 78.27,
    width: 228.09,
    height: 169.47,
    transform: "translate(621.4 326.01) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.08,
    y: 55.29,
    width: 155.24,
    height: 215.42,
    transform: "translate(473.7 -147.69) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 161.67,
    width: 155.24,
    height: 2.67,
    transform: "translate(367.32 -41.32) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.27,
    y: 197.9,
    width: 222.85,
    height: 9.56,
    transform: "translate(621.39 405.36) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.58,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.11,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(432.9 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.79,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.32,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(497.32 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.53,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(561.74 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.21,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.74,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(626.16 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.42,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.95,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(690.58 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.63,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.16,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(755 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.84,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.37,
    y: 70.78,
    width: 10.68,
    height: 50.09,
    transform: "translate(819.42 191.65) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.05,
    y: 70.78,
    width: 21.53,
    height: 54.47,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 203.72,
    y: 283,
    width: 26.69,
    height: 99.4,
    transform: "translate(434.12 665.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.16 382.4 203.72 382.4 203.72 373.45 212.82 373.45 208.16 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.75,
    y: 283,
    width: 26.69,
    height: 99.4,
    transform: "translate(818.2 665.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.72,
    y: 283,
    width: 195.91,
    height: 95.96,
    transform: "translate(603.35 661.96) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.16,
    y: 287.25,
    width: 189.02,
    height: 26.32,
    transform: "translate(603.35 600.82) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,295.43h93.39c4.33,0,8.48-3.25,11.46-9H243.52C246.5,292.18,250.64,295.43,255,295.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.19 382.4 399.63 382.4 399.63 373.45 390.53 373.45 395.19 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.16,
    y: 317.82,
    width: 189.02,
    height: 26.32,
    transform: "translate(603.35 661.96) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,326h93.39c4.33,0,8.48-3.24,11.46-9H243.52C246.5,322.76,250.64,326,255,326Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.16,
    y: 348.39,
    width: 189.02,
    height: 26.32,
    transform: "translate(603.35 723.1) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,356.57h93.39c4.33,0,8.48-3.24,11.46-9H243.52C246.5,353.33,250.64,356.57,255,356.57Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.88,410.53h-1.07a.92.92,0,0,1-.85-.87l-6.58-45.82h5l4.36,45.52A1,1,0,0,1,369.88,410.53Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.88,410.53h-1.07a.92.92,0,0,1-.85-.87l-6.58-45.82h5l4.36,45.52A1,1,0,0,1,369.88,410.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6,410.53h-1.07a.92.92,0,0,1-.85-.87l-6.58-45.82h5l4.37,45.52A1,1,0,0,1,383.6,410.53Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6,410.53h-1.07a.92.92,0,0,1-.85-.87l-6.58-45.82h5l4.37,45.52A1,1,0,0,1,383.6,410.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.16,410.53h1.07a.92.92,0,0,0,.85-.87l6.58-45.82h-5l-4.36,45.52A1,1,0,0,0,307.16,410.53Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.16,410.53h1.07a.92.92,0,0,0,.85-.87l6.58-45.82h-5l-4.36,45.52A1,1,0,0,0,307.16,410.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,410.53h1.07a.92.92,0,0,0,.85-.87l6.58-45.82h-5l-4.36,45.52A1,1,0,0,0,293.44,410.53Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,410.53h1.07a.92.92,0,0,0,.85-.87l6.58-45.82h-5l-4.36,45.52A1,1,0,0,0,293.44,410.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66,309.51h33.68c6-20.75,27.48-37.12,49.5-37.12h10.94c23,0,37.92,17.93,33.22,40.06a44.64,44.64,0,0,1-4.29,11.67l-5.31,32.19c-.68,4.16-4,7.53-7.4,7.53H284.62c-3.4,0-6.72-3.37-7.4-7.53L270.74,317C270.05,312.88,272.26,309.51,275.66,309.51Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66,309.51h33.68c6-20.75,27.48-37.12,49.5-37.12h10.94c23,0,37.92,17.93,33.22,40.06a44.64,44.64,0,0,1-4.29,11.67l-5.31,32.19c-.68,4.16-4,7.53-7.4,7.53H284.62c-3.4,0-6.72-3.37-7.4-7.53L270.74,317C270.05,312.88,272.26,309.51,275.66,309.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.23,398.68l8.34,3.82a.59.59,0,0,1,.32.76l-2.63,6.79a1.44,1.44,0,0,1-1.9.72c-2.88-1.38-4.19-2.19-7.86-3.87a98.15,98.15,0,0,1-11.22-6.5c-2.72-2-.72-4.7.63-4.1,6.1,2.69,10,2.93,12.83,2.25A2.23,2.23,0,0,1,267.23,398.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38,296.43s-53.33.66-54.16,21.68c-1.18,30.22-5.64,80.39-5.64,80.39l9,4s15.76-50.34,16.32-73.94c15-3.72,53.57,0,58.1-12.26a40.43,40.43,0,0,0,1.71-19.87Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38,296.43s-53.33.66-54.16,21.68c-1.18,30.22-5.64,80.39-5.64,80.39l9,4s15.76-50.34,16.32-73.94c15-3.72,53.57,0,58.1-12.26a40.43,40.43,0,0,0,1.71-19.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,241.12c-.47,1.94-.94,3.69-1.47,5.51s-1.08,3.59-1.66,5.37c-1.17,3.56-2.46,7.1-3.94,10.6A86.64,86.64,0,0,1,325.51,273a50.64,50.64,0,0,1-3.38,5.11,29,29,0,0,1-4.65,4.9l-.15.13-.32.24a7.65,7.65,0,0,1-3.36,1.2,9.35,9.35,0,0,1-2.27,0,13.82,13.82,0,0,1-3.07-.74,32.8,32.8,0,0,1-4.47-2,75.41,75.41,0,0,1-7.43-4.72c-2.32-1.67-4.56-3.4-6.74-5.2s-4.27-3.64-6.34-5.62a3.06,3.06,0,0,1,3.6-4.88l.05,0c2.36,1.31,4.74,2.7,7.13,4s4.75,2.61,7.12,3.83,4.75,2.38,7,3.32a20.47,20.47,0,0,0,3.19,1.06,3.15,3.15,0,0,0,1,.13c.07,0,0,0-.21,0a3.15,3.15,0,0,0-1.42.53l-.48.36a17.6,17.6,0,0,0,2.59-3.19,43.19,43.19,0,0,0,2.41-4.09,95.64,95.64,0,0,0,4.11-9.28c1.23-3.22,2.38-6.52,3.45-9.86s2.07-6.77,3-10l0-.12a6.12,6.12,0,0,1,11.85,3.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.11,403h10a.63.63,0,0,1,.66.61l.49,7.91a1.59,1.59,0,0,1-1.56,1.59c-3.48-.06-5.15-.27-9.55-.27-2.7,0-8.16.28-11.9.28s-3.63-3.69-2.05-4c7.11-1.5,9.86-3.57,12.37-5.55A2.58,2.58,0,0,1,316.11,403Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.75,296.43s-48.37,4.08-47.18,25.09c1.3,23,22.54,81.5,22.54,81.5h9.78s-8.37-53.57-11.32-77c13.64,0,45.26,2.56,49.8-9.73a40.35,40.35,0,0,0,1.7-19.87Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.68,262.4a16.27,16.27,0,0,0-2.72-3.34c-2,1.86-3.09,7.27-3.09,7.27l2.73.24S287.74,265.55,287.68,262.4Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.64,257.54l-3.11-1.35a1.82,1.82,0,0,0-2.28.73l-1.48,2.44a1.83,1.83,0,0,0,.25,2.2l4.27,4.45,7.12-.29a2.25,2.25,0,0,0,1.93-1.23l.82-1.61a2.23,2.23,0,0,0-.71-2.89C282.14,258.47,277.64,257.54,277.64,257.54Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.92,239.07c-1.42,9-3.27,28.43.5,57.73l39.65-.37c-.24-20.31,2.94-39.37,6.05-58a5.54,5.54,0,0,0-4.71-6.41,147.33,147.33,0,0,0-34.23,0A8.53,8.53,0,0,0,325.92,239.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.48,235.9c1.17,2.89,2.1,5.66,3.06,8.52s1.78,5.73,2.57,8.64,1.48,5.88,2,8.91a73.06,73.06,0,0,1,1.21,9.37c.06.81.07,1.65.08,2.49v1.28a7.85,7.85,0,0,1-1,3.75,6.87,6.87,0,0,1-1.66,1.94,6.54,6.54,0,0,1-1,.66,6.09,6.09,0,0,1-1,.44,8.3,8.3,0,0,1-2.94.52,13.36,13.36,0,0,1-3.5-.55,31.1,31.1,0,0,1-4.84-1.91c-1.45-.72-2.81-1.47-4.14-2.25a109.51,109.51,0,0,1-14.67-10.49,3.05,3.05,0,0,1,3.27-5.1l.07,0c5.17,2.46,10.43,5,15.55,7.11,1.28.52,2.55,1,3.8,1.43a20.58,20.58,0,0,0,3.41.93c.46.08.87.07.82,0a1.51,1.51,0,0,0-.79.14,4.1,4.1,0,0,0-.46.21,3.36,3.36,0,0,0-.54.36,4.29,4.29,0,0,0-1,1.11,3.69,3.69,0,0,0-.52,1.64l-.05-.91c-.06-.62-.11-1.23-.2-1.87a106.62,106.62,0,0,0-3.74-16c-1.6-5.37-3.44-10.85-5.31-16.06l0-.05a6.12,6.12,0,0,1,11.43-4.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,211.91l-4.79,4-6.54,5.43a18.9,18.9,0,0,1,.42,2.63c.31,3.16-.38,6.06-4.21,7.53a5,5,0,0,0-3.16,3.09c-.52,1.67.09,3.54,5.35,3.54,7.73,0,11.76-3.44,13.28-5.13a1.37,1.37,0,0,0,.07-1.71C354,226.93,355.38,217.33,356.63,211.91Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,236.41a3,3,0,0,1,.67,1.36,5.49,5.49,0,0,1,1.45-1.36,5.18,5.18,0,0,1,2.77,3.24,14.61,14.61,0,0,1-4.16-1.54,7.11,7.11,0,0,1-2.78.86C341.52,237.24,343.51,236.41,343.51,236.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.63,236.41a12.16,12.16,0,0,1,2.65,5.83s12.8-3.2,12.2-11.55a13,13,0,0,0-3.55-1.09S354.18,234.6,345.63,236.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,236.41a13.46,13.46,0,0,0-2.82,5.83s-6.56-6-.17-11.48a17.1,17.1,0,0,1,3.39-.71S339.66,233.5,343.51,236.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.3,221.31a19.28,19.28,0,0,1,.42,2.64c2.44-.49,5.69-3.08,6-5.57a11.48,11.48,0,0,0,.09-2.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,194.69c-6,4.27-2.66,14.28,2.48,10.45S343.2,191.21,338.3,194.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.61,203.61c-1.67,7.66-2.25,12.22-6.78,15.72a10.2,10.2,0,0,1-16.5-7.34c-.6-7.14,2.23-18.48,10.29-20.65A10.32,10.32,0,0,1,358.61,203.61Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.06,197.92c-4.25-1.17-15.21,1.62-19.1-2.53-4.17-4.45,1.91-6.62,3.71-5.07-2.27-2.6-1.43-5.38,1.79-5.13,2.35.18,3.09,2.78,3.09,2.78s-.39-4.55,3.65-4.23c3.66.28,3.67,5.22,3.67,5.22s8.74-2.47,11.66,5.87c5.5-.12,5.38,11.46-5.69,15.58C353.35,208.19,353.14,200.29,355.06,197.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.35,196.5a1.11,1.11,0,0,1-.2-2.21,1.6,1.6,0,0,0,.65-.81,2.62,2.62,0,0,0,.12-2.08,1.11,1.11,0,1,1,2-.92,4.87,4.87,0,0,1-.24,4.17,3.22,3.22,0,0,1-2.15,1.83A.65.65,0,0,1,362.35,196.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.86,210.72a7,7,0,0,1-4.21,2.6c-2.17.39-2.83-1.61-1.87-3.54.86-1.75,3-4.05,5-3.55S361.14,209,359.86,210.72Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.48,204.31c-.1.63-.51,1.1-.92,1.05s-.67-.6-.58-1.23.51-1.1.93-1S345.57,203.68,345.48,204.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.34,203.46c-.1.63-.51,1.1-.92,1s-.67-.6-.58-1.23.51-1.1.93-1.05S338.44,202.83,338.34,203.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52,203.71a20.3,20.3,0,0,1-3,4.49,3.08,3.08,0,0,0,2.55.61Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,212.05a5.52,5.52,0,0,0,4-1.64.19.19,0,0,0-.28-.25,5.25,5.25,0,0,1-4.39,1.47.2.2,0,0,0-.21.16.19.19,0,0,0,.17.21A6.27,6.27,0,0,0,343,212.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.35,200.68a.35.35,0,0,0,.16-.08.37.37,0,0,0,0-.53,3.57,3.57,0,0,0-3.13-1.24.37.37,0,1,0,.12.74,2.86,2.86,0,0,1,2.46,1A.37.37,0,0,0,348.35,200.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,200.27a.38.38,0,0,0,.34-.07,3.09,3.09,0,0,1,2.67-.72.38.38,0,0,0,.46-.26.37.37,0,0,0-.26-.46h0a3.83,3.83,0,0,0-3.34.87.37.37,0,0,0-.05.52A.36.36,0,0,0,335.79,200.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.81,256.94l-4.38-2.72a2.77,2.77,0,0,0-3.84.92l-.51.86a2.76,2.76,0,0,0,.28,3.25l3,3.47s2.63,6.13,5.68,4.51l2.32-4Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32,264.78A18.79,18.79,0,0,0,351,260.7c-2.2,1.88-4,7.88-4,7.88l2.69.58A5,5,0,0,0,353.32,264.78Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,309.51H334.91c-3.4,0-5.6,3.37-4.92,7.53l6.48,39.27c.69,4.16,4,7.53,7.41,7.53H380.4Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,309.51H334.91c-3.4,0-5.6,3.37-4.92,7.53l6.48,39.27c.69,4.16,4,7.53,7.41,7.53H380.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.28,413.9h1.5a1,1,0,0,0,1-1L158,289h-6.19l-5.5,123.76A1,1,0,0,0,147.28,413.9Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.28,413.9h1.5a1,1,0,0,0,1-1L158,289h-6.19l-5.5,123.76A1,1,0,0,0,147.28,413.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28,413.9h1.5a1,1,0,0,0,1-1L141,289h-6.2l-5.49,123.76A1,1,0,0,0,130.28,413.9Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28,413.9h1.5a1,1,0,0,0,1-1L141,289h-6.2l-5.49,123.76A1,1,0,0,0,130.28,413.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,413.9h-1.5a1,1,0,0,1-1-1L329.21,289h6.19l5.5,123.76A1,1,0,0,1,339.93,413.9Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,413.9h-1.5a1,1,0,0,1-1-1L329.21,289h6.19l5.5,123.76A1,1,0,0,1,339.93,413.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.93,413.9h-1.5a1,1,0,0,1-1-1L346.21,289h6.2l5.49,123.76A1,1,0,0,1,356.93,413.9Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.93,413.9h-1.5a1,1,0,0,1-1-1L346.21,289h6.2l5.49,123.76A1,1,0,0,1,356.93,413.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.78,
    y: 286.48,
    width: 241.3,
    height: 2.55,
    style: {
      fill: "#00AB65"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.76,247l-2.28,16.77c-.72,5.58-1.47,11.18-2,16.68-.07.69-.12,1.36-.18,2l-.08,1a2.52,2.52,0,0,0,0-.5,2.16,2.16,0,0,0-.11-.47,2.44,2.44,0,0,0-.15-.35,1.54,1.54,0,0,0-.14-.23c-.18-.23-.2-.2-.15-.15a2,2,0,0,0,.34.29,10.55,10.55,0,0,0,1.32.77,53.55,53.55,0,0,0,7.35,2.73c5.24,1.59,10.75,3,16.19,4.31l-.62,4.77a119.81,119.81,0,0,1-17.34-1.79,50.54,50.54,0,0,1-8.91-2.35,19.25,19.25,0,0,1-2.47-1.16,10.86,10.86,0,0,1-1.4-.95,7.83,7.83,0,0,1-1.59-1.7,6.61,6.61,0,0,1-.76-1.53,7.69,7.69,0,0,1-.24-1,10,10,0,0,1-.06-1l0-1.11c0-.74,0-1.48.06-2.21.24-5.84.77-11.54,1.39-17.24s1.34-11.35,2.23-17Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,295l-3.67,3.35a2.85,2.85,0,0,1-3.15.46l-4.05-1.95s-6-.25-6.87-3.92l1.56-2.85,9.31-1a4.38,4.38,0,0,1,2.74.61l3.84,2.35A1.88,1.88,0,0,1,151.41,295Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,212.56c1,5.76,1.76,16.27-2.36,20,0,0,10,5.26,16.63,14.44,7-5.58,1.15-13.91,1.15-13.91-6.34-1.71-6-6.44-4.79-10.85Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,236.59s-.53-4.88-3.19-7.29c-2.23-2-14-.9-17.67-.49a2.05,2.05,0,0,0-1.6,1.14l-2.68,5.6Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,236.59s-.53-4.88-3.19-7.29c-2.23-2-14-.9-17.67-.49a2.05,2.05,0,0,0-1.6,1.14l-2.68,5.6Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,234c-7.24,2.36-8.8,12.07-8.14,19.62l14.61,9s3.55-11,3.52-16.92C125.69,239.44,120.65,232.42,115.73,234Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.56,260.43a1.4,1.4,0,0,1-1-.39,1.46,1.46,0,0,1-.16-.21.92.92,0,0,1-.13-.24,1.83,1.83,0,0,1-.08-.25,1.15,1.15,0,0,1,0-.26,1.37,1.37,0,0,1,.4-1,1.4,1.4,0,0,1,1.92,0,1.37,1.37,0,0,1,.4,1,1.15,1.15,0,0,1,0,.26,1,1,0,0,1-.08.25.9.9,0,0,1-.12.24l-.17.21A1.36,1.36,0,0,1,118.56,260.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.75,259.51h0a1.36,1.36,0,0,1-.87-1.22h0a1.34,1.34,0,0,1-1.47.22h0a1.37,1.37,0,0,1-.79-1.26h0a1.33,1.33,0,0,1-1.48.13h0a1.35,1.35,0,0,1-.71-1.3h0a1.36,1.36,0,0,1-1.49.05h0a1.36,1.36,0,0,1-.46-1.86h0a1.37,1.37,0,0,1,1.87-.46h0a1.4,1.4,0,0,1,.65,1.27h0a1.34,1.34,0,0,1,1.42-.09h0a1.37,1.37,0,0,1,.72,1.23h0a1.35,1.35,0,0,1,1.41-.17h0a1.36,1.36,0,0,1,.79,1.18h0a1.38,1.38,0,0,1,1.4-.25h0a1.36,1.36,0,0,1,.76,1.76h0a1.35,1.35,0,0,1-1.26.86h0A1.47,1.47,0,0,1,115.75,259.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,255a1.24,1.24,0,0,1-.27,0,1,1,0,0,1-.25-.08.9.9,0,0,1-.24-.12l-.2-.17a1.06,1.06,0,0,1-.17-.2c0-.08-.09-.16-.13-.24a2.41,2.41,0,0,1-.08-.25,2.45,2.45,0,0,1,0-.27,2.11,2.11,0,0,1,0-.26,2.58,2.58,0,0,1,.08-.26,1,1,0,0,1,.13-.23,1.57,1.57,0,0,1,.17-.21l.2-.17a1.34,1.34,0,0,1,.24-.12l.25-.08a1.4,1.4,0,0,1,1.22.37,1.57,1.57,0,0,1,.17.21,1.71,1.71,0,0,1,.13.23,1.25,1.25,0,0,1,.07.26,1.09,1.09,0,0,1,0,.26,1.24,1.24,0,0,1,0,.27,1.17,1.17,0,0,1-.07.25c0,.08-.08.16-.13.24a1.06,1.06,0,0,1-.17.2A1.37,1.37,0,0,1,107.59,255Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,248.13c-.61,8.32-2.46,22.32-7,45.9l-39.14-1.16c1-14.45-.53-25.22-4.07-50.51a8.23,8.23,0,0,1,7.31-9.31c2.51-.26,5.37-.47,8.24-.53a125,125,0,0,1,17.78.53c1.9.23,3.87.54,5.75.86A13.42,13.42,0,0,1,161.77,248.13Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.7,202c.09.77.58,1.35,1.08,1.28s.84-.73.75-1.5-.58-1.35-1.08-1.29S149.61,201.2,149.7,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.23,200.54l1.79-.76S151.24,201.34,150.23,200.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,203.17a20.85,20.85,0,0,0,3.34,4.6,3.33,3.33,0,0,1-2.69.85Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,195.21a.47.47,0,0,0,0-.46.46.46,0,0,0-.61-.21,4.52,4.52,0,0,0-2.6,3.26.45.45,0,0,0,.39.51.45.45,0,0,0,.51-.39h0a3.64,3.64,0,0,1,2.09-2.56A.38.38,0,0,0,149.79,195.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.06,201.8c1.72,9.41,2.25,13.43,7.62,17.73,8.08,6.46,19.27,2.29,20.4-7.45,1-8.77-2-22.69-11.7-25.35A13.06,13.06,0,0,0,123.06,201.8Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,204.44c1.58,5.17,5.36,17.67-3,20.46-6.53,2.18-27,3.92-29.35-8.07-2.43-12.39,8.62-21.22,8.62-21.22s-8.76-7.18-3.15-15c7.23-10.08,24.55-4.38,29.68,2.74C151.61,190.28,143.8,204.44,143.8,204.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,226.62A29.25,29.25,0,0,1,117,224.46c-4.64-2-7.35-5.09-7.84-8.94-1.64-13.07,10.52-20.25,10.65-20.32l.48.83c-.12.07-11.73,6.94-10.17,19.37.56,4.41,4.26,6.88,7.27,8.17,5.94,2.56,13.61,2.54,15.47,1.18l.57.78C132.49,226.24,130.45,226.62,128,226.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,193.74c-.11,1.67-1.49,4,4.3,4.83s13.85.78,15.51-.61,3.28-4.73-.18-4.43S116.5,190.88,116.31,193.74Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.63,205.91a7.55,7.55,0,0,0,4.44,3.63c2.52.74,3.82-1.51,3.15-3.91-.61-2.16-2.66-5.15-5.2-4.84S139.5,203.76,140.63,205.91Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.64 403.56 210.92 403.38 206.43 380.22 197.15 380.39 201.64 403.56",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,393.47c2.45,9.25,11.48,19,11.48,19l-12.88-3.28-5.63-8,1-2.12Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.45,397.77a19.64,19.64,0,0,0,.19,3.24c.55,3.82,2.23,14,2.23,14h.88a90.42,90.42,0,0,1-.71-9.34c.12-2.51,1.74,1.93,3.7,4.45s5.49,4.81,11.2,5c6.68.21,9.35-.07,7.21-1.74s-6.7-2.75-6.7-2.75a20.31,20.31,0,0,1-9-7.55,23.56,23.56,0,0,0-8.29-7.17C199.6,395.94,199.49,397,199.45,397.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.51 372.09 246.35 372.46 233.1 352.76 224.9 359.77 234.51 372.09",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,363.73c8.61,4,22.39,3.22,22.39,3.22l-11.2,9-9.61-.72-1-2.13Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5,373.94A19.81,19.81,0,0,0,238,376c3.14,2.19,11.63,7.8,11.63,7.8l.54-.69a90.49,90.49,0,0,1-7.29-5.83c-1.78-1.82,2.49-.05,5.55.13s6.92-1,10.57-5.4c4.29-5.11,5.72-7.4,3.18-6.86s-6.16,3.38-6.16,3.38a18,18,0,0,1-11.11,1.94,20.83,20.83,0,0,0-10.39,1.61C234.25,372.58,234.92,373.36,235.5,373.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1,293.35S204.46,284,211,300.22c11.42,28.26,27.53,60.64,27.53,60.64l-7.78,6.44s-27.63-25.58-37.45-54c-11.74,3.8-49.09,16-62.77,16-14.61,0-20.58-12.45-15.3-33.14a4.16,4.16,0,0,1,4-3.11C128.5,293.14,141.1,293.35,141.1,293.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,301.6s52-1.56,52.45,16.86c.72,30.47,9.31,74.13,9.31,74.13l-9.49.88S183.93,358.74,179.83,329c-18.52,1.2-35.6.37-49.28.37-15.33,0-16.6-16.83-1.68-36.48C138,292.87,147.17,301.6,147.17,301.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,290.55,114,294c-.15.27.16.55.62.57l40.28,1.19c.35,0,.65-.15.68-.37l.46-3.49c0-.25-.27-.46-.66-.47l-39.63-1.18A.71.71,0,0,0,115.09,290.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28,295.14l-1.06,0c-.21,0-.37-.12-.35-.25l.63-4.54c0-.13.21-.23.42-.23l1.06,0c.21,0,.37.12.35.25l-.63,4.53C120.68,295.05,120.49,295.15,120.28,295.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,296.09l-1.06,0c-.21,0-.37-.12-.35-.25l.64-4.54c0-.13.2-.23.41-.23l1.06,0c.22,0,.37.12.36.25l-.64,4.54C152.29,296,152.11,296.09,151.89,296.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.09,295.61l-1.06,0c-.22,0-.37-.12-.35-.25l.63-4.54c0-.13.21-.23.42-.23l1.06,0c.21,0,.37.12.35.25l-.63,4.54C136.49,295.52,136.3,295.62,136.09,295.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.33,251.61h25.29a1.22,1.22,0,0,1,1.17,1.55l-9.46,32.45a1.2,1.2,0,0,1-1.16.87h-25.3a1.2,1.2,0,0,1-1.16-1.55l9.45-32.45A1.21,1.21,0,0,1,184.33,251.61Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.79 252.8 209.38 253.38 199.67 283.99 175.08 283.4 184.79 252.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.02 252.5 208.61 252.6 199.5 283.39 174.91 283.29 184.02 252.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,253.14c0,1,.15,2.18.23,3.29s.23,2.27.38,3.4q.42,3.39,1.12,6.68a47.81,47.81,0,0,0,1.78,6.3c.37,1,.78,2,1.22,2.88.22.46.46.89.7,1.33l.37.61s-.07,0,0,0a4.44,4.44,0,0,0,1.59.93,19.64,19.64,0,0,0,2.88.87,56.77,56.77,0,0,0,6.69,1c4.62.45,9.45.67,14.17.77l.48,4.79a90.52,90.52,0,0,1-14.91,1.69,54.24,54.24,0,0,1-7.79-.32,27.33,27.33,0,0,1-4.19-.85,12.43,12.43,0,0,1-4.78-2.47,8.68,8.68,0,0,1-1.26-1.35l-.64-.9c-.41-.6-.81-1.2-1.15-1.81a30.74,30.74,0,0,1-1.89-3.7,48.2,48.2,0,0,1-2.58-7.56,65.61,65.61,0,0,1-1.49-7.64c-.17-1.27-.3-2.55-.41-3.84s-.18-2.52-.2-4Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55,238.39c6.3,5.93,4.78,21.38,4.78,21.38l-12.06,2.11s-7.45-11.08-4.83-15.72C149.16,241.32,155.15,235.18,158.55,238.39Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,261.13a1.39,1.39,0,0,1-1-.4,1.2,1.2,0,0,1-.17-.21,1.67,1.67,0,0,1-.12-.23A2,2,0,0,1,162,260a2.11,2.11,0,0,1,0-.26,1.36,1.36,0,0,1,.39-1,1.73,1.73,0,0,1,.21-.17,1,1,0,0,1,.23-.12,1.29,1.29,0,0,1,.26-.08,1.36,1.36,0,0,1,1.62,1.33,1.09,1.09,0,0,1,0,.26,1.12,1.12,0,0,1-.08.26,1,1,0,0,1-.12.23,1.2,1.2,0,0,1-.17.21A1.37,1.37,0,0,1,163.33,261.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,261.85a1.36,1.36,0,0,1,1.24-1.47h0a1.34,1.34,0,0,1,1.27.64h0a1.38,1.38,0,0,1,1.09-.92h0a1.38,1.38,0,0,1,1.31.57h0a1.34,1.34,0,0,1,1-1h0a1.35,1.35,0,0,1,1.34.49h0a1.36,1.36,0,0,1,1-1h0a1.35,1.35,0,0,1,1.66,1h0a1.36,1.36,0,0,1-1,1.66h0a1.37,1.37,0,0,1-1.41-.47h0a1.37,1.37,0,0,1-1.06,1.05h0a1.38,1.38,0,0,1-1.38-.56h0a1.35,1.35,0,0,1-1.11,1h0a1.36,1.36,0,0,1-1.35-.63h0a1.37,1.37,0,0,1-1.17.92h-.11A1.37,1.37,0,0,1,152.37,261.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,263.24a1.24,1.24,0,0,1-.27,0l-.25-.08a1.79,1.79,0,0,1-.24-.12l-.2-.17a.87.87,0,0,1-.17-.21,1.71,1.71,0,0,1-.13-.23,1.25,1.25,0,0,1-.07-.26,1.09,1.09,0,0,1,0-.26,1.24,1.24,0,0,1,0-.27,1.17,1.17,0,0,1,.07-.25c0-.08.08-.16.13-.24a1.06,1.06,0,0,1,.17-.2l.2-.17a1.08,1.08,0,0,1,.24-.12,1,1,0,0,1,.25-.08,1.34,1.34,0,0,1,1.22.37,1.06,1.06,0,0,1,.17.2c.05.08.09.16.13.24a2.41,2.41,0,0,1,.08.25,2.45,2.45,0,0,1,0,.27,2.11,2.11,0,0,1,0,.26,2.58,2.58,0,0,1-.08.26,1.71,1.71,0,0,1-.13.23,1.12,1.12,0,0,1-.17.21A1.37,1.37,0,0,1,151.27,263.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,276.22l-4.18-.28a4.66,4.66,0,0,0-2.94.79l-7.67,5.15-.06,3.25c2.46,2.86,7.9.3,7.9.3l5.05-.17a2,2,0,0,0,1.83-1.32l1.83-5A2,2,0,0,0,204.2,276.22Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.59,418.41h1.13a1,1,0,0,0,.9-.92l7-48.44h-5.29l-4.61,48.12A1.05,1.05,0,0,0,117.59,418.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.59,418.41h1.13a1,1,0,0,0,.9-.92l7-48.44h-5.29l-4.61,48.12A1.05,1.05,0,0,0,117.59,418.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09,418.41h1.13a1,1,0,0,0,.9-.92l7-48.44h-5.29l-4.61,48.12A1.05,1.05,0,0,0,103.09,418.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09,418.41h1.13a1,1,0,0,0,.9-.92l7-48.44h-5.29l-4.61,48.12A1.05,1.05,0,0,0,103.09,418.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.89,418.41h-1.14a1,1,0,0,1-.89-.92l-7-48.44h5.28l4.61,48.12A1.05,1.05,0,0,1,183.89,418.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.89,418.41h-1.14a1,1,0,0,1-.89-.92l-7-48.44h5.28l4.61,48.12A1.05,1.05,0,0,1,183.89,418.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,418.41h-1.14a1,1,0,0,1-.89-.92l-7-48.44h5.28l4.61,48.12A1.05,1.05,0,0,1,198.39,418.41Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,418.41h-1.14a1,1,0,0,1-.89-.92l-7-48.44h5.28l4.61,48.12A1.05,1.05,0,0,1,198.39,418.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,311.63h-35.6c-6.32-21.94-29-39.24-52.32-39.24H117.7c-24.36,0-40.08,19-35.12,42.34a48.18,48.18,0,0,0,4.53,12.34l5.62,34c.72,4.39,4.23,7.95,7.82,7.95H207.71c3.59,0,7.1-3.56,7.82-7.95l6.85-41.52C223.11,315.19,220.78,311.63,217.18,311.63Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,311.63h-35.6c-6.32-21.94-29-39.24-52.32-39.24H117.7c-24.36,0-40.08,19-35.12,42.34a48.18,48.18,0,0,0,4.53,12.34l5.62,34c.72,4.39,4.23,7.95,7.82,7.95H207.71c3.59,0,7.1-3.56,7.82-7.95l6.85-41.52C223.11,315.19,220.78,311.63,217.18,311.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 12.694963, 26.302828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.25,155.62a3.06,3.06,0,0,1-1.84-.63l-12.92-10H231.64a3.88,3.88,0,0,1-3.87-3.87V105.37a3.88,3.88,0,0,1,3.87-3.87h91.17a3.88,3.88,0,0,1,3.87,3.87v35.75a3.88,3.88,0,0,1-3.87,3.87h-1.55v7.62a3,3,0,0,1-3,3ZM231.64,102.5a2.88,2.88,0,0,0-2.87,2.87v35.75a2.88,2.88,0,0,0,2.87,2.87h72.2L317,154.19a2,2,0,0,0,3.24-1.58V144h2.55a2.88,2.88,0,0,0,2.87-2.87V105.37a2.88,2.88,0,0,0-2.87-2.87Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28,125.51H318.5a2.26,2.26,0,0,0,2.26-2.26h0A2.27,2.27,0,0,0,318.5,121H275.28a2.27,2.27,0,0,0-2.26,2.27h0A2.26,2.26,0,0,0,275.28,125.51Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.1,125.51h21.4a2.26,2.26,0,0,0,2.26-2.26h0A2.27,2.27,0,0,0,266.5,121H245.1a2.27,2.27,0,0,0-2.26,2.27h0A2.26,2.26,0,0,0,245.1,125.51Z",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -320.76,
    y: -134.9,
    width: 69.41,
    height: 4.52,
    rx: 2.26,
    transform: "matrix(-1, 0, 0, -1, 0, 0)",
    style: {
      fill: "#00AB65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,116.12H318.5a2.26,2.26,0,0,0,2.26-2.26h0a2.27,2.27,0,0,0-2.26-2.27H236a2.27,2.27,0,0,0-2.26,2.27h0A2.26,2.26,0,0,0,236,116.12Z",
    style: {
      fill: "#00AB65"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "matrix(1, 0, 0, 1, 214.7659, 202.844742)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(1, 0, 0, 1, 214.7659, 202.844742)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "matrix(5.432837, 0, 0, 5.027992, 200.205917, 171.065445)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-5.267 6.274a6.766 6.766 0 0 0 1.756-1.084L3.31 5.177a6.81 6.81 0 0 0 7.84 10.68zm3.624-3.624a6.808 6.808 0 0 0-10.68-7.84l9.596 9.596a6.77 6.77 0 0 0 1.084-1.756z",
    style: {
      fill: "rgb(243, 32, 19)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessage);
export default __webpack_public_path__ + "static/media/no-message.b8231bb40f5e050b7bdfb368027a0a83.svg";
export { ForwardRef as ReactComponent };